export default "__VITE_ASSET__BPJcQuEv__"